<template>
  <div class="main-box">
    <img src="@/assets/images/cmbCreditCard/title_bg.png" class="title-img" />
    <div class="apply-box">
      <img
        src="@/assets/images/cmbCreditCard/apply_now.png"
        alt="立即申请"
        class="apply-img"
        @click="goApply"
      />
      <div class="receive-rights underline" @click="goReceiveRights">
        已成功申请的用户，点此领取半价过隧道权益
      </div>
      <!-- 更多信用卡权益 -->
      <div class="more-rights-box">
        <img
          src="@/assets/images/cmbCreditCard/more_rights.png"
          class="more-rights-img"
        />
        <div class="more-rights">
          <div v-for="(item, index) in rights" :key="index">
            {{ item }}
          </div>
          <!-- （1）立即申请，点击后进入招商银行信用卡申请H5页面，填写对应信息，完成信息卡申请；<br />
          （2）已成功申请，领取信用卡权益。点击后进入权益领取页面。 -->
        </div>
      </div>
      <!-- 活动细则 -->
      <div class="activity-rules-box">
        <div class="activity-title">活动细则</div>
        <div class="activity-rules">
          <div class="rules-item">
            1.<span>用户首次申请招商银行信用卡成功后，可获120元隧道通行券；</span>
          </div>
          <div class="rules-item">
            2.<span>
              申卡成功用户可通过“便捷青岛”APP-“隧e通”-招行申卡活动页面领取8张5元隧道券，连续领取3个月；
            </span>
          </div>
          <div class="rules-item">
            3.<span>请务必保持申卡手机号与便捷青岛注册手机号一致，否则无法发放优惠券；</span>
          </div>
          <div class="rules-item">
            4.<span>优惠券有效时长1个月；</span>
          </div>
          <div class="rules-item">
            5.<span>每次通行只可使用1张优惠券；</span>
          </div>
          <div class="rules-item">
            6.<span>优惠券不兑现、不找零、不开具发票。</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { setStore } from '@/utils/index'
import { participateInActivity } from '@/api/cmbCreditCard'
export default {
  name: 'cmbCreditCard',
  data () {
    return {
      rights: [
        '（1）持卡人可参与招商银行“掌上生活”首刷礼活动。',
        '（2）每周三领取半价美食优惠券，其他日期享普通优惠活动。',
        '（3）积分兑换精美礼品。',
        '（4）如需了解更多，请详询4008205555。'
      ]
    }
  },
  created () {
    const token = this.$route.query.token
    if (token) {
      setStore('token', token)
    }
  },
  methods: {
    // 立即申请
    goApply () {
      const { activeId } = this.$route.query
      const params = {
        activeId // 活动编号
      }
      if (window._czc) {
        window._czc.push(['_trackEvent', '招商银行信用卡活动-便捷青岛', '立即申请-招行信用卡', '招行信用卡介绍页', '', '010'])
      }
      participateInActivity(params).then(res => {
        const resData = res.data
        if (resData.code === 200 && resData.result) {
          // 跳转招行信用卡申请页面
          window.location.href = 'https://res.cc.cmbimg.com/itafront/Frog/index.html#/login3/api3xxylhj/remote?webAddress=N47FHXM2018X404500HZ&dsid=288184'
        }
      })
    },
    // 点击领取半价过隧道权益
    goReceiveRights () {
      const { activeId, token } = this.$route.query
      this.$router.push({
        path: '/cmbCreditCardRights',
        query: {
          token,
          activeId
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import "~@/assets/css/cmbCreditCard.scss";
.apply-img {
  max-width: 100%;
  padding-top: (250vw / 7.5);
}

// 更多信用卡权益
.more-rights-box {
  display: flex;
  flex-direction: column;
  align-items: center;

  width: (640vw / 7.5);
  padding-top: (50vw / 7.5);
  margin: 0 auto;
}

.more-rights-img {
  width: (466vw / 7.5);
  height: (74vw / 7.5);
  z-index: 1;
}

.more-rights {
  margin-top: (-43vw / 7.5);
  width: calc((640vw - 60vw) / 7.5);
  min-height: calc((268vw - 110vw) / 7.5);
  padding: (80vw / 7.5) (30vw / 7.5) (35vw / 7.5);
  background: #fff9ef;
  border-radius: (24vw / 7.5);

  font-size: (24vw / 7.5);
  font-family: Source Han Sans CN, Source Han Sans CN-Normal;
  font-weight: Normal;
  text-align: left;
  color: #bc5715;
  line-height: (33vw / 7.5);
  letter-spacing: (1vw / 7.5);
}
</style>
